import React, { useState, useRef, useEffect } from 'react'
import { Affix } from 'antd'
import {
  Card,
  BatchAll,
  BatchStart,
  BatchStop,
  BatchOptions,
  BatchNum
} from 'component'
import { Icon } from 'meinian-package/src/component'
import StyleMultiGraph from 'component/waterfall.card/style/styleMultiGraph'
import MNWaterfallApi from 'component/waterfall/masonryApi'
import { Dropdown } from 'meinian-package/src/baseComponent'
import { convertParams } from 'component/util'
import globalData from 'meinian-package/src/common/globalData'
import util from 'meinian-package/src/utils/util'
import Rank, { RANK_DEFAULT_VALUE } from 'component/filter/rank'
import classNames from 'classnames'
import Filter from '../../components/styleFilter'
import useStyleFilterQueryParams from '../../components/styleFilter/useStyleFilterQueryParams'
import { StyleSwitchingView, UploadStyle, VIEW_MODE, STYLE_RULES_KEY, STYLE_TYPE_KEY, STYLE_RULES_VALUE } from '../../components/fixedOperation'
import { RULES, getRules } from '../../components/fixedOperation/imageSize'
import { getViewConfig } from '../../../component/navUser/viewSettingModal'
import styles from './index.module.less'

export default () => {
  const [hasFilter, setHasFilter] = useState(false)
  const queryParams = useStyleFilterQueryParams()
  const [filterParams, setFilterParams] = useState({
    ...queryParams,
    ...RANK_DEFAULT_VALUE,
  })
  const [params, setParams] = useState({
    queryType: 'all',
  })
  const $masonry = useRef()
  const [columnRulesType, setColumnRulesType] = useState(STYLE_RULES_VALUE)
  const [viewMode, setViewMode] = useState(VIEW_MODE.TEXT)
  const [isBatch, setIsBatch] = useState(false)
  const [batchAll, setBatchAll] = useState([])

  useEffect(() => {
    globalData.get(STYLE_RULES_KEY, setColumnRulesType, STYLE_RULES_VALUE)
    globalData.get(STYLE_TYPE_KEY, setViewMode, VIEW_MODE.TEXT)
  }, [])

  useEffect(() => {
    const onResize = () => {
      $masonry.current.layout()
    }
    if (!$masonry.current) return
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [$masonry.current])

  const [total, setTotal] = useState(0)
  useEffect(() => {
    if ($masonry.current) {
      setTotal($masonry.current?.total)
    }
  }, [$masonry.current?.total])

  const [viewConfig, setViewConfig] = useState({})
  useEffect(() => {
    getViewConfig().then(res => {
      setViewConfig(res)
    })
  }, [])
  return <div className={styles['meinian-home-all-style']}>
    <UploadStyle
      style={{ right: 16, bottom: 158 }}
      onClick={() => setIsBatch(false)}
      onChange={() => {
        $masonry.current?.init()
      }}
    />
    <StyleSwitchingView
      style={{ right: 16, bottom: 102 }}
      columnRulesType={columnRulesType}
      viewMode={viewMode}
      onColumnRulesType={(val) => {
        setColumnRulesType(val)
        $masonry.current?.init()
        globalData.set(STYLE_RULES_KEY, val)
      }}
      onViewMode={(val) => {
        setViewMode(val)
        globalData.set(STYLE_TYPE_KEY, val)
        $masonry.current?.init()
      }}
    />
    <div className="meinian-home-all-style-header">
      <div className="meinian-home-all-style-header-left">
        <span style={{ color: 'var(--m-text-1)' }}>款式</span>
        <span style={{ color: 'var(--m-text-3)', marginLeft: '8px', }}>{total}</span>
      </div>
      <div className="meinian-home-all-style-header-right">
        <div style={{ marginRight: '8px' }}>
          <LayerSelect
            onChange={(val, cur) => {
              util.track('mn-header-link', {
                module1: '侧边栏',
                module2: '款式图库',
                module3: cur.title,
              })
              setParams(pre => ({ ...pre, queryType: val }))
            }}
            value={params.queryType}
          />
        </div>
        <Filter
          displayTextClassName="fill-grey-bg"
          hasFilter={hasFilter}
          setHasFilter={(val) => {
            setHasFilter(val)
          }}
          defaultParams={RANK_DEFAULT_VALUE}
          value={filterParams}
          hiddenChildFlag={false}
          visible={hasFilter}
          onChange={(val) => {
            if (params.platformId !== val.platformId) {
              setFilterParams({ ...val, ...RANK_DEFAULT_VALUE })
            } else {
              setFilterParams({ ...val })
            }
          }}
          onCancel={() => {
            setHasFilter(false)
          }}
        />
        <div style={{ marginRight: '8px' }}>
          <Rank
            platformId={filterParams.platformId}
            displayTextClassName="fill-grey-bg"
            trigger="click"
            placement="bottomRight"
            onChange={(val) => {
              setFilterParams(pre => ({ ...pre, ...val }))
            }}
            allowClear={false}
            value={filterParams}
          />
        </div>
        <BatchStart
          displayTextClassName="fill-grey-bg"
          onClick={() => {
            setIsBatch(!isBatch)
            setHasFilter(false)
          }}
        />
      </div>
    </div>
    <div className="screen-options">
      {
        isBatch && <Affix offsetTop={64} target={() => document.body}>
          <div className="batch-operation">
            <div className="meinian-space" />
            <BatchAll style={{ marginRight: 16 }} keyValues={batchAll?.map(i => `${i.imageGroupEntityId},${i.inspirationId}`)} infos={batchAll} />
            <BatchNum style={{ marginRight: 40 }} />
            <BatchOptions.Collect style={{ marginRight: 16 }} data={batchAll} onChange={() => { setIsBatch(false); $masonry.current?.init() }} />
            <BatchOptions.Download fileName="全部采集" onChange={() => setIsBatch(false)} />
            <BatchOptions.Export
              fileName="全部采集"
              onChange={() => {
                util.track('mn-statement-export', {
                  module1: '批量导出',
                  module2: '款式图库',
                })
                setIsBatch(false)
              }}
            />
            <BatchStop onClick={() => { setIsBatch(false) }} />
          </div>
        </Affix>
      }
    </div>
    <MNWaterfallApi
      pageSize={40}
      gutter={16}
      idKey={['imageGroupEntityId', 'inspirationId']}
      renderItem={(props) => {
        if (viewMode === VIEW_MODE.MULTI_GRAPH) {
          return <StyleMultiGraph {...props} />
        }
        if (viewMode === VIEW_MODE.IMAGE) {
          return <Card.Image {...props} />
        }
        if (viewMode === VIEW_MODE.TEXT) {
          return <Card.ImageText {...props} />
        }
        return <Card.Image {...props} />
      }}
      rule={viewMode === VIEW_MODE.IMAGE ? getRules(columnRulesType) : RULES.M}
      onTotal={(_total) => {
        setTotal(_total)
      }}
      cardProps={{
        isBatch,
        showMoveImage: true,
        allStyleFlag: true,
        trackSourceType: '款式图库',
        viewConfig
      }} // allStyleFlag 区别于灵感集的硬编码
      url="/image-bus/inspiration/list-blog"
      method="post"
      params={{
        ...convertParams({ ...params, ...filterParams }),
      }}
      ref={$masonry}
      afterLoad={data => setBatchAll(data)}
      emptyText="暂无相关款式"
      emptyType="image"
    />
  </div>
}

// all-全部款式,
// mine-我采集的,
// mine_upload-我上传的,
// pending_my_mark-待我审核,
// mine_pending_submit-待我提审,
// i_comment-我评论的,
// i_annotation-我批注的

const LayerSelect = ({ onChange, value }) => {
  const options = [
    { label: '全部款式', value: 'all' },
    { label: '我采集的', value: 'mine' },
    // { label: '我上传的', value: 'mine_upload' },
    { label: '待我审核', value: 'pending_my_mark', line: true },
    { label: '待我提审', value: 'mine_pending_submit', },
    { label: '我评论的', value: 'i_comment', line: true },
    { label: '我批注的', value: 'i_annotation' }
  ]
  const [visible, setVisible] = useState(false)

  return <Dropdown
    placement="bottomRight"
    trigger="click"
    overlayClassName=""
    overlay={<div className={styles.layerSelectDropdownContent}>
      {
        options.map(item => <>
          {
          item.line && <div className="item-line" key={item.value} />
        }
          <div
            key={item.value}
            className={classNames('item', 'fill-white-bg', { active: item.value === value })}
            onClick={() => {
              onChange(item.value, item)
              setVisible(false)
            }}
          >{item.label}</div>
        </>)
      }
    </div>}
    visible={visible}
    onVisibleChange={_visible => setVisible(_visible)}
    getPopupContainer={node => node?.parentElement || document.body}
  >
    <span className={styles['all-styles-display-text']} style={{ cursor: 'pointer', position: 'relative' }}>
      {
        options.find(item => item.value === value)?.label || '全部款式'
      }
      <Icon
        type="m-Vxing_xia"
        style={{ marignLeft: '4px', transform: visible ? 'rotate(180deg)' : undefined, transition: 'all 0.3s' }}
      />
    </span>
  </Dropdown>
}
